import { Radio } from "antd";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import Button from "../../shared/Button";

const CreateStep7Part2 = ({prevStep,nextStep}) => {
  const { updatePlaceDetail, createInfoData ,apiUpdateResideces,setIsEditPlaceCompleter} = useCreatePlace();

  const [space, setspace] = useState(createInfoData.stepTen.cancel_regulation);
  const onChange = e => {
    setspace(e.target.value);
  };
  const gotonext = ()=>{
    updatePlaceDetail("stepTen",{
      cancel_regulation:space
    })
    nextStep()
  }
  const {id}=useParams()
  const update = (data) => {
    updatePlaceDetail("stepTen",{
      cancel_regulation:space
    })
       setIsEditPlaceCompleter(true);
    
      
  };
  return (
    <div className="createsteps">
      {" "}<h2>قوانین لغو رزرو</h2>
      <p className="w-[100%] ">
        در این قسمت میزبان تعیین می کند ، در صورتی که میهمان ، رزرو قطعی شده خود
        را لغو کند چه مبلغی از اجاره بها قابل پرداخت خواهد بود . سیاسیت لغو رزرو
        هر اقامتگاه در “ نمایه “ آن اقامتگاه و همچنین سند رزرو ثبت می شود و برای
        مهمان و میزبان قابل مشاهده خواهد بود ، لذا مهمان پیش از رزرو اقامتگاه یا
        لغو رزرو از عواقب مالی آن آگاه می شود .
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[18px] text-[700]">
        انتخاب نوغ قانون کنسلی رزرو{" "}
      </h4>
      <p className="w-[100%] ">
        در ورت لعو رزرو قطعی ، هرگونه بازگشت وجوه مطابق مقررات لغو رزرو همان
        اقامتگاه انجام خواهد شد .
      </p>
      <div className="createsteps--radiogroup mt-[50px] ">
        <Radio.Group onChange={onChange} value={space} defaultValue={space}>
          <div className="createstep2--grid">
            <div
              className={`createsteps--radiogroupbox ${space === "permissive"
                ? "createsteps--radiogroupbox--active"
                : ""}`}
            >
              <Radio value="permissive">
                <div className={`createsteps--radiogrouplabel`}>
                  <h6>سهل گیرانه</h6>
                  <p>
                    در صورتی که رزرو ، ۲۴ ساعت پیش از تاریخ ورود لغو گردد . کل
                    اجاره بها پس از کسر ۱۰ درصد کارمزد لغو ، به میهمان باز
                    پرداخت می گردد .
                  </p>
                </div>
              </Radio>
            </div>
            <div
              className={`createsteps--radiogroupbox ${space === "normal"
                ? "createsteps--radiogroupbox--active"
                : ""}`}
            >
              <Radio value={"normal"}>
                <div className="createsteps--radiogrouplabel">
                  <h6>متعادل</h6>
                  <p>
                    در صورتی که رزرو ، ۳ روز کامل پیش از تاریخ ورود لغو گردد .
                    کل اجاره بها پس از کسر ۱۰ درصد کارمزد لغو ، به میهمان باز
                    پرداخت می گردد .
                  </p>
                </div>
              </Radio>
            </div>
            <div
              className={`createsteps--radiogroupbox ${space === "strict"
                ? "createsteps--radiogroupbox--active"
                : ""}`}
            >
              <Radio value={"strict"}>
                <div className="createsteps--radiogrouplabel">
                  <h6>سخت گیرانه</h6>
                  <p>
                    در صورتی که رزرو ، ۵ روز کامل پیش از تاریخ ورود لغو گردد .
                    کل اجاره بها پس از کسر ۲۰ درصد کارمزد لغو ، به میهمان باز
                    پرداخت می گردد .
                  </p>
                </div>
              </Radio>
            </div>
          </div>
        </Radio.Group>
      </div>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
     { id &&<Button onClick={()=>update()}> 
                بروزرسانی اقامتگاه
              </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button varient="primary" onClick={()=>gotonext()}>
          مرحله بعدی
        </Button>
      </div>
    </div>
  );
};

export default CreateStep7Part2;
